/**
 * Title color key -> hex for profile, battle UI, achievement toasts.
 * Keys match titles.color in DB: white, blue, purple, golden.
 */
export const TITLE_COLORS = {
  white: '#e0e0e0',
  blue: '#5eb3f6',
  purple: '#b388ff',
  golden: '#ffd700'
};

export const getTitleColorHex = (colorKey) => TITLE_COLORS[colorKey] || TITLE_COLORS.white;
